import React from "react";

const Commando = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Commando</b>
      </div>
      <div className="helpDescription">
        <b>Information about the Commando perk</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          The <b>Commando</b> is designed for players who prefer to take on
          enemies with automatic weapons, offering solid support to the team
          with high sustained damage. The Commando perk emphasizes clearing out
          large groups of Zeds with rapid fire and precision aiming,
          particularly at medium range.
        </div>
        <div className="perkInfo">
          <b>Weapons</b>: The Commando has access to automatic firearms. These
          weapons allow for consistent, high-output damage, effective at mowing
          down groups of Zeds quickly.
        </div>
        <div className="listText">
          <b>Benefits</b> acquired by leveling this perk:
          <div className="bonusList">
            <ul>
              <li>Bonuses for Commando weapons:</li>
              <ul>
                <li>Increase in damage;</li>
                <li>Increase in fire speed;</li>
                <li>Increase in reload speed;</li>
                <li>Increase in amount ammunition magazines;</li>
                <li>Increase in pickup amount of ammunition;</li>
                <li>Discount on ammunition;</li>
                <li>Reduced weapon price;</li>
              </ul>
              <li>General bonuses:</li>
              <ul>
                <li>Increase in vision of cloaked enemies;</li>
                <li>Increase in carry weight;</li>
                <li>Increase in recoil control;</li>
              </ul>
            </ul>
          </div>
          <b>Team Role</b>: Commandos provide great support by taking out crowds
          of enemies, providing critical cover fire, and clearing areas of
          weaker Zeds. They also possess the ability to detect cloaked enemies,
          making them valuable for team coordination and crowd control.
        </div>
      </div>
    </div>
  );
};

export default Commando;
